import { useState } from 'react';
import type { Project } from '../../types/crm';
import {
  exportCustomersEnquiryExcel,
  type ProjectExportContext,
} from '../../lib/projectExport';

interface CustomersEnquiryExportButtonProps {
  /** All projects in scope (not search-filtered). */
  projects: Project[];
  ctx: ProjectExportContext;
  disabled?: boolean;
}

export function CustomersEnquiryExportButton({
  projects,
  ctx,
  disabled,
}: CustomersEnquiryExportButtonProps) {
  const [busy, setBusy] = useState(false);

  async function handleExport() {
    if (projects.length === 0) return;
    setBusy(true);
    try {
      await exportCustomersEnquiryExcel(projects, ctx);
    } catch (err) {
      window.alert(err instanceof Error ? err.message : 'Export failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className="btn-secondary btn-sm"
      disabled={disabled || busy || projects.length === 0}
      onClick={() => void handleExport()}
      title="Export all projects to CUSTOMERS ENQUIRY Excel format"
    >
      {busy ? 'Exporting…' : `Export customers enquiry (${projects.length})`}
    </button>
  );
}
